var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{staticClass:"mr-6",attrs:{"src":`${_vm.publicPath}assets/img/foto-default.png`,"height":"40"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }